
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"800","height":"800","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.15 5.063C6.051 5.358 6 5.673 6 6v1H5a3 3 0 00-3 3v7a1 1 0 001 1h3a3 3 0 003 3h6a3 3 0 003-3h1.086l-5-5H7a1 1 0 00-1 1v2H4v-6a1 1 0 011-1h5.086l-2-2H8v-.086l-1.85-1.85zM10.913 7H16V6a1 1 0 00-1-1H9c-.028 0-.055.001-.082.003L7.385 3.471A2.986 2.986 0 019 3h6a3 3 0 013 3v1h1a3 3 0 013 3v7c0 .298-.13.566-.337.749L19.914 16H20v-6a1 1 0 00-1-1h-6.086l-2-2zm4.996 4.996l-.906-.906A1 1 0 0116 10h2a1 1 0 110 2h-2a.988.988 0 01-.09-.004zM8 18v-3h8v3a1 1 0 01-1 1H9a1 1 0 01-1-1z","fill":"#000"}}),_c('path',{attrs:{"d":"M3 3l18 18","stroke":"#000","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    